import { useContext, useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { UserRegisterRepository } from 'interfaceAdapter/repositories/UserRegister';
import { SupportUserQuery } from 'interfaceAdapter/queries/SupportUser';

export const useSupportUserRegistrationAuth = () => {
    const diContainer = useContext(diContainerContext);
    const userRegisterRepository = diContainer.resolve(UserRegisterRepository);
    const supportUserQuery = diContainer.resolve(SupportUserQuery);
    const [complete, setComplete] = useState(false);
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [authError, setAuthError] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate();
    const params = useParams();

    const auth = useCallback(
        async (urlId: string) => {
            if (urlId === '') {
                return;
            }
            const { status } = await supportUserQuery.checkToken(false);
            if (status !== false) {
                setComplete(true);
                setIsLoggedIn(true);
                return;
            }
            try {
                await userRegisterRepository.supporterUrlAuth(urlId);
                setComplete(true);
                setShowSnackbar(true);
                setTimeout(() => window.location.replace(`/supporter/registration/password/${urlId}`), 1500);
            } catch (error) {
                console.error(error);
                setComplete(true);
                setAuthError(true);
            }
        },
        [navigate, userRegisterRepository],
    );

    useEffect(() => {
        if (!params.url_id) {
            return;
        }
        auth(params.url_id);
    }, [params.url_id, auth]);

    return {
        complete,
        authError,
        showSnackbar,
        isLoggedIn,
    };
};
